import React from "react";
import {connect} from "react-redux";
import _ from 'lodash'

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import InputLabel from "@material-ui/core/InputLabel";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import Check from "@material-ui/icons/Check";
import Button from "components/CustomButtons/Button.jsx";

// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";

import styles from "assets/jss/material-dashboard-pro-react/views/form";
import regularFormsStyle from "assets/jss/material-dashboard-pro-react/views/regularFormsStyle";

import {
  plaformsFetch,
  plaformFilter
} from 'actions/platforms'

import {
  referralLinkSave,
  referralLinkEditSave,
  referralLinkLiteralFetch,
  referralLinkFetch,
  referralLinksFetch
} from 'actions/referralLinks'

import {
  ibFetch
} from 'actions/ibs'
import {profileFetch} from 'actions/profiles'
import {
  danger,
} from 'actions/notification'

import store from "store/index";


var tradingAccountTypes = {
  VARIABLE: {key: 'VARIABLE', label:'Variable'},
  FIXED: {key: 'FIXED', label: 'Fixed'},
  RAW_COMMISSION: {key: 'RAW_COMMISSION', label: 'Raw_Commission'},
  SILVER: {key: 'SILVER', label: 'Silver'},
  GOLD: {key: 'GOLD', label: 'Gold'},
  ALL_SHARE: {key: 'ALL_SHARE', label: 'All Share'}
}

var leverages = {
  LEVERAGE_500_1: {key: 'LEVERAGE_500_1', label:'500:1'},
  LEVERAGE_400_1: {key: 'LEVERAGE_400_1', label:'400:1'},
  LEVERAGE_200_1: {key: 'LEVERAGE_200_1', label: '200:1'},
  LEVERAGE_100_1: {key: 'LEVERAGE_100_1', label: '100:1'},
  LEVERAGE_50_1: {key: 'LEVERAGE_50_1', label: '50:1'},
  LEVERAGE_1_1: {key: 'LEVERAGE_1_1', label: '1:1'}
}

const clientAccountCurrencies = {
  USD: {key: 'USD', label:'USD'},
  EUR: {key: 'EUR', label: 'EUR'},
  GBP: {key: 'GBP', label: 'GBP'}
}

class Rules extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      form: {
      ibId: this.props.match.params.id,
      referralLinkId: 0,
      profileId: 0,
      accountPlatforms: [],
      accountTypes: [],
      accountLeverages: [],
      accountCurrencies: [],
    },
    };
  }
  componentDidMount(){

    let configVars = store.getState().config;

    if (configVars['application']) {
      
      if (configVars['application']!='kenya') {  
        
        leverages = _.reject(leverages, function(e) {
          return e.key === 'LEVERAGE_400_1'
        });
        
        tradingAccountTypes = _.reject(tradingAccountTypes, function(e) {
          return e.key === 'ALL_SHARE'
        });

      }
    }
    const {form} = this.state;
    let myProfileId = 0;

    this.props.profileFetch(this.props.match.params.profileId).then((e1) => {
      
      myProfileId = this.props.match.params.profileId;
      
      this.setState({
          ...this.state,
          profileId: myProfileId,
        });

      this.setState({
        ...this.state,
        form: {
          ...form,
          profileId: myProfileId
        }
      })

      this.props.referralLinksFetch(this.props.match.params.profileId, this.props.match.params.id)
        .then((e2) => {
      
        if (e2.content.length>0) {
        this.setState({
            ...this.state,
            form:{
              ibId: this.props.match.params.id,
              profileId: myProfileId,
              referralLinkId: e2.content[e2.content.length-1].referralLinkId,
              literalId: e2.content[e2.content.length-1].literalId,
              accountPlatforms: e2.content[e2.content.length-1].accountPlatforms,
              accountTypes: e2.content[e2.content.length-1].accountTypes,
              accountLeverages: e2.content[e2.content.length-1].accountLeverages,
              accountCurrencies: e2.content[e2.content.length-1].accountCurrencies,
            }
          })
      }

      });

    });

    this.props.ibFetch(this.props.match.params.id);
   
    this.props.plaformFilter({size: 100})
    this.props.platformsFetch()
    
  }
  componentWillMount(){

  }
  sendState() {
    return this.state;
  }
 
submit(e){
    e.preventDefault()
    let data = {...this.props.wizardData, ...this.state.form}

    let configVars = store.getState().config;
    
    if(data.accountPlatforms === ''){
      delete data.accountPlatforms
    }
    if(data.accountTypes === ''){
      delete data.accountTypes
    }
    if(data.accountLeverages === ''){
      delete data.accountLeverages
    }
    if(data.accountCurrencies === ''){
      delete data.accountCurrencies
    }
    
    if (data.referralLinkId===0) {
      this.props.save(data)
        .then(e => {

        this.setState({
          ...this.state,
          referrallink:'Loading...',
          showCreateReferralLink: true,
        });

        setTimeout(function() {

          this.props.referralLinkFetch(e.referralLinkId)
          .then((responseFetch) => {
            this.setState({
              ...this.state,
              referrallink:configVars['registrationAppUrl']+this.filterLiteralId(responseFetch.literalId),
              showCreateReferralLink: false,
              form: {
                literalId:responseFetch.literalId
              }
            });
            
          });

          ;

        }.bind(this), 10000);

          this.props.saveWizardData(e)
          //this.props.goToNextStep({data: e})
          window.location.reload(true);
          //this.props.history.goBack();
      })
      .catch(e=>{
        this.props.danger(e+'',4);
        //this.props.history.goBack();
      })
    } else {
      this.props.saveEdit(data)
        .then(e => {

          this.props.saveWizardData(e)
          this.props.goToNextStep({data: e})
      })
      .catch(e=>{this.props.danger(e+'',4);})
    }

  }

  filterLiteralId(literalId) {

    if (typeof literalId === 'string' || literalId instanceof String) {

      if (literalId.includes('_')) {
        
        let realLiteralId = literalId.split("_").pop();
        return realLiteralId;
      
      } else {

        return 0;
      
      }

    } else {

      return 0;
      
    }

    /*let realLiteralId = literalId.replace("MYSCOPE_EXTERNAL_IB_ID_", "");
    realLiteralId = literalId.replace("MYSCOPE_REFERRALLINK_LITERAL_ID_", "");
    return realLiteralId;*/
    
  }

/*setCheckboxValue(key, item){
    const {form} = this.state
    let keyItem = form[key]
    
    keyItem = item;

    this.setState({
      ...this.state,
      form: {
        ...form,
        [key]: keyItem
      }
    })
  }*/

setCheckboxValue(key, item){
    const {form} = this.state
    let keyItem = form[key]
    if(keyItem.includes(item)){ // remove it from list
      keyItem = keyItem.filter((x) => x !== item)
    } else { //add it in list
      keyItem.push(item)
    }
    this.setState({
      ...this.state,
      form: {
        ...form,
        [key]: keyItem
      }
    })
}

/*renderCheckbox(options){
    const {classes} = this.props
    const values = this.state.form[options.key]
    return(
      <div key={options.key} style={{paddingTop: '34px'}}>
        <InputLabel
          htmlFor={options.key}
          className={classes.selectLabel}
        >
          {options.label}
        </InputLabel>
        <div style={{borderTop: '1px solid #D2D2D2'}}>
          {options.options.map((item, i) => {
            
            return(
              <div
                key={item.key}
                className={
                classes.checkboxAndRadio + " " + classes.checkboxAndRadioHorizontal}
              >
                <FormControlLabel
                  control={
                    <Checkbox
                      tabIndex={-1}
                      onClick={() => this.setCheckboxValue(options.key, item.key)}
                      checked={(values!==null && item.key!== undefined)?values.includes(item.key):false}
                      checkedIcon={
                        <Check className={classes.checkedIcon} />
                      }
                      icon={<Check className={classes.uncheckedIcon} />}
                      classes={{
                        checked: classes.checked
                      }}
                    />
                  }
                  classes={{
                    label: classes.label
                  }}
                  label={item.label}
                />
              </div>
            )
          })}
        </div>
      </div>
    )
  }*/

  renderCheckbox(options){
    const {classes} = this.props
    const values = this.state.form[options.key]
    return(
      <div key={options.key} style={{paddingTop: '34px'}}>
        <InputLabel
          htmlFor={options.key}
          className={classes.selectLabel}
        >
          {options.label}
        </InputLabel>
        <div style={{borderTop: '1px solid #D2D2D2'}}>
          {options.options.map((item, i) => {
            return(
              <div
                key={item.key}
                className={
                classes.checkboxAndRadio + " " + classes.checkboxAndRadioHorizontal}
              >
                <FormControlLabel
                  control={
                    <Checkbox
                      tabIndex={-1}
                      onClick={() => this.setCheckboxValue(options.key, item.key)}
                      checked={values.includes(item.key)}
                      checkedIcon={
                        <Check className={classes.checkedIcon} />
                      }
                      icon={<Check className={classes.uncheckedIcon} />}
                      classes={{
                        checked: classes.checked
                      }}
                    />
                  }
                  classes={{
                    label: classes.label
                  }}
                  label={item.label}
                />
              </div>
            )
          })}
        </div>
      </div>
    )
  }

  render() {
    const { platforms } = this.props
    
    return (
      <form onSubmit={(e) => this.submit(e)}>
      <GridContainer justify="center">
        <GridItem xs={12} sm={3} md={3}>
            {this.renderCheckbox({
              options: platforms.map((x) => {return{key:x.name, label:x.name}}),
              label: 'Platforms',
              key: 'accountPlatforms'
            })}

          </GridItem>
          <GridItem xs={12} sm={3} md={3}>

            {this.renderCheckbox({
              options: Object.values(tradingAccountTypes),
              label: 'Trading Account Types',
              key: 'accountTypes'
            })}

          </GridItem>
          <GridItem xs={12} sm={3} md={3}>
            
            {this.renderCheckbox({
              options: Object.values(leverages),
              label: 'Leverages',
              key: 'accountLeverages'
            })}

          </GridItem>
          <GridItem xs={12} sm={3} md={3}>
            
            {this.renderCheckbox({
              options: Object.values(clientAccountCurrencies),
              label: 'Client Account Currencies',
              key: 'accountCurrencies'
            })}

          </GridItem>
          {/*<GridItem xs={12} sm={11} md={11}>
            {this.renderCheckbox({
              options: platforms.map((x) => {return{key:x.name, label:x.name}}),
              label: 'Platforms',
              key: 'accountPlatforms'
            })}

            {this.renderCheckbox({
              options: Object.values(tradingAccountTypes),
              label: 'Trading Account Types',
              key: 'accountTypes'
            })}

            {this.renderCheckbox({
              options: Object.values(leverages),
              label: 'Leverages',
              key: 'accountLeverages'
            })}

            {this.renderCheckbox({
              options: Object.values(clientAccountCurrencies),
              label: 'Client Account Currencies',
              key: 'accountCurrencies'
            })}
          </GridItem>*/}
        <GridItem xs={12} sm={12} md={12} lg={10}>
          
        </GridItem>
        {<GridItem sm={11}>
          <div style={{float: 'right'}}>
            <Button
              color="success"
              /*onClick={(e) => this.props.goToNextStep()}*/
              type="submit"
              style={{position:'absolute', bottom:'10px', right:'40px'}}
            >
              Next
            </Button>
          </div>
        </GridItem>}
      </GridContainer>
      </form>
    );
  }
}

//export default withStyles(style)(Rules);

const state=(state)=>({
  ibs: state.ibs,
  platforms: state.platforms.list,
  profiles: state.profiles
})
const dispatch=(dispatch)=>({
  referralLinkFetch:(id)=>dispatch(referralLinkFetch(id)),
  referralLinkLiteralFetch:(id)=>dispatch(referralLinkLiteralFetch(id)),
  referralLinksFetch:(profileId, ibId)=>dispatch(referralLinksFetch(profileId, ibId)),
  save:(data)=>dispatch(referralLinkSave(data)),
  saveEdit:(data)=>dispatch(referralLinkEditSave(data)),
  ibFetch:(id)=>dispatch(ibFetch(id)),
  profileFetch:(id)=>dispatch(profileFetch(id)),
  platformsFetch: () => dispatch(plaformsFetch()),
  plaformFilter: (filter) => dispatch(plaformFilter(filter)),
  danger:(text,sec)=>dispatch(danger(text,sec)),
  
})
export default withStyles({...styles, ...regularFormsStyle})(connect(state,dispatch)(Rules))



// WEBPACK FOOTER //
// ./src/views/IbTree/Wizard/Rules.jsx